import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UNAPPROVES_COUNT } from 'manager/http-constants';
import { LoadingState } from 'src/app/shared/html-parts/loading/loading-state';
import { CommonService } from 'src/app/shared/service/common.service';
import { DbOperationService } from 'src/app/shared/service/db-operation.service';
import { PlatformComponent } from '../platform.component';

@Component({
  selector: 'app-d101',
  templateUrl: './d101.component.html',
  styleUrls: ['./d101.component.scss', '../platform.component.scss'],
})

/**
 * 事務局メニュー
 */
export class D101Component extends PlatformComponent {
  // 件数格納先
  countUnapprovesData = 0;

  // 件数格納先
  countUnapprovesList: any[];

  constructor(
    public route: ActivatedRoute,
    public commonService: CommonService,
    public dbOperationService: DbOperationService,
    public loadingState: LoadingState,
    private router: Router
  ) {
    super(route, commonService, dbOperationService, loadingState);
  }

  ngOnInit(): void {
    // 未承認件数取得
    this.getUnapprovesCount();
  }

  /**
   * 未承認件数取得
   */
  public getUnapprovesCount(): void {
    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart(UNAPPROVES_COUNT);

    // 未承認件数取得
    this.dbOperationService
      .getNoTemplateData(UNAPPROVES_COUNT, false)
      .subscribe((response) => {
        // 未承認件数を格納
        this.countUnapprovesList = response.body;

        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, UNAPPROVES_COUNT);
      });
  }

  /**
   * マイページ(B301)へ遷移する
   */
  public moveB301(): void {
    // マイページ(B301)へ遷移
    this.router.navigate(['pages/platform/b301']);
  }

  /**
   * ユーザ一覧(B220)へ遷移する
   */
  public moveB220(): void {
    // ユーザ一覧(B220)へ遷移
    this.router.navigate(['pages/platform/b220']);
  }

  /**
   * 会員入会審査(D211)へ遷移する
   */
  public moveD211(): void {
    // 会員入会審査(D211)へ遷移
    this.router.navigate(['pages/platform/secretariat-list/d211']);
  }

  /**
   * 会員更新審査(D212)へ遷移する
   */
  public moveD212(): void {
    // 会員更新審査(D212)へ遷移
    this.router.navigate(['pages/platform/secretariat-list/d212']);
  }

  /**
   * 課題ソリューション審査(D221)へ遷移する
   */
  public moveD221(): void {
    // 課題ソリューション審査(D221)へ遷移
    this.router.navigate(['pages/platform/secretariat-list/d221']);
  }

  /**
   * マッチング提案審査(D231)へ遷移する
   */
  public moveD231(): void {
    // マッチング提案審査(D231)へ遷移
    this.router.navigate(['pages/platform/secretariat-list/d231']);
  }

  /**
   * 会員主催イベント審査(D241)へ遷移する
   */
  public moveD241(): void {
    // 会員主催イベント審査(D241)へ遷移
    this.router.navigate(['pages/platform/secretariat-list/d241']);
  }

  /**
   * 分科会審査一覧（D251）へ遷移する
   */
  public moveD251(): void {
    // 分科会審査一覧（D251）へ遷移
    this.router.navigate(['pages/platform/secretariat-list/d251']);
  }

  /**
   * 問い合わせ一覧（D261）へ遷移する
   */
  public moveD261(): void {
    // 問い合わせ一覧（D261）へ遷移
    this.router.navigate(['pages/platform/secretariat-list/d261']);
  }

  /**
   * 掲示板コメント（D271）審査へ遷移する
   */
  public moveD271(): void {
    // 掲示板コメント（D271）審査へ遷移
    this.router.navigate(['pages/platform/secretariat-list/d271']);
  }

  /**
   * 連携事例審査(D281)へ遷移する
   */
  public moveD281(): void {
    // 連携事例審査(D281)へ遷移
    this.router.navigate(['pages/platform/secretariat-list/d281']);
  }

  /**
   * 掲示板通報審査(D291)へ遷移する
   */
  public moveD291(): void {
    // 掲示板通報審査(D291)へ遷移
    this.router.navigate(['pages/platform/secretariat-list/d291']);
  }

  /**
   * 会員一覧（F111）へ遷移する
   */
  public moveF111(): void {
    // 会員一覧（F111）へ遷移
    this.router.navigate(['pages/platform/master/f111']);
  }

  /**
   * 課題・ソリューション一覧（F121）へ遷移する
   */
  public moveF121(): void {
    // 課題・ソリューション一覧（F121）へ遷移
    this.router.navigate(['pages/platform/master/f121']);
  }

  /**
   * 提案一覧（F131）へ遷移する
   */
  public moveF131(): void {
    // 提案一覧（F131）へ遷移
    this.router.navigate(['pages/platform/master/f131']);
  }

  /**
   * 会員主催イベント一覧（F141）へ遷移する
   */
  public moveF141(): void {
    // 会員主催イベント一覧（F141）へ遷移
    this.router.navigate(['pages/platform/master/f141']);
  }

  /**
   * 分科会一覧（F151）へ遷移する
   */
  public moveF151(): void {
    // 分科会一覧（F151）へ遷移
    this.router.navigate(['pages/platform/master/f151']);
  }

  /**
   * 分科会参加者一覧（F171）へ遷移する
   */
  public moveF171(): void {
    // 分科会参加者一覧（F171）へ遷移
    this.router.navigate(['pages/platform/master/f171']);
  }

  /**
   * お知らせ一覧（G101）へ遷移する
   */
  public moveG101(): void {
    // お知らせ一覧（G101）へ遷移
    this.router.navigate(['pages/platform/g101']);
  }

  /**
   * 事例紹介記事一覧（J201）へ遷移する
   */
  public moveJ201(): void {
    // 事例紹介記事一覧（J201）へ遷移
    this.router.navigate(['pages/platform/j201']);
  }

  /**
   * ダッシュボード（I101）へ遷移する
   */
  public moveI101(): void {
    // ダッシュボード（I101）へ遷移
    this.router.navigate(['pages/platform/i101']);
  }
}
